module.exports = __webpack_public_path__ + "img/Weapon_142.6b514146.png";